import * as CryptoJS from 'crypto-js';
import {Constants} from "../common/Constants";

export class Utils {
  public static getMessageSignature(message: string) {
    let secret = CryptoJS.enc.Base64.parse(Constants.API_SECRET);
    let hmac_obj = CryptoJS.HmacSHA512( message, secret);
    let hmac_sign = CryptoJS.enc.Base64.stringify(hmac_obj);
    return hmac_sign;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/prochart.utils.ts